import { useNavigate } from 'react-router-dom'
import { Bell, BellOff } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'
import { useNotifications } from '@/hooks/useNotifications'
import Skeleton from '@/components/Skeleton'

function timeAgo(dateStr: string): string {
  const diff = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000)
  if (diff < 60) return 'Baru saja'
  if (diff < 3600) return `${Math.floor(diff / 60)} menit lalu`
  if (diff < 86400) return `${Math.floor(diff / 3600)} jam lalu`
  return `${Math.floor(diff / 86400)} hari lalu`
}

export default function Notifikasi() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { notifs, loading, markAllRead } = useNotifications(user?.id)

  if (!user) {
    return (
      <div className="max-w-lg mx-auto px-4 py-16 text-center">
        <Bell size={40} className="mx-auto text-gray-300 mb-3" />
        <p className="text-sm text-gray-400">Masuk untuk melihat notifikasi.</p>
      </div>
    )
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-lg font-semibold text-gray-800">Notifikasi</h1>
        {notifs.some(n => !n.is_read) && (
          <button
            onClick={markAllRead}
            className="text-xs text-blue-600 hover:underline"
          >
            Tandai semua dibaca
          </button>
        )}
      </div>

      {loading ? (
        <div className="space-y-3">
          {[...Array(3)].map((_, i) => <Skeleton key={i} className="h-16 rounded-xl" />)}
        </div>
      ) : notifs.length === 0 ? (
        <div className="text-center py-16">
          <BellOff size={36} className="mx-auto text-gray-300 mb-2" />
          <p className="text-sm text-gray-400">Belum ada notifikasi.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {notifs.map(n => (
            <button
              key={n.id}
              onClick={() => {
                if (n.order_id) navigate(`/status?order_id=${n.order_id}`)
              }}
              className={`w-full text-left px-4 py-3 rounded-xl border transition-colors ${
                n.is_read
                  ? 'bg-white border-gray-100 text-gray-500'
                  : 'bg-blue-50 border-blue-100 text-gray-800'
              } ${n.order_id ? 'hover:bg-blue-50 cursor-pointer' : 'cursor-default'}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="flex items-start gap-2">
                  {!n.is_read && (
                    <span className="mt-1.5 w-2 h-2 rounded-full bg-blue-500 shrink-0" />
                  )}
                  <p className={`text-sm ${!n.is_read ? 'font-medium' : ''}`}>{n.pesan}</p>
                </div>
                <span className="text-xs text-gray-400 shrink-0">{timeAgo(n.created_at)}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
